import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ICTask } from '../../helper/Interfaces';
import { LocalStorageHelper } from '../../helper/LocalStorageHelper';
import { RootState } from '../store';

type TaskProps = {
  taskDetailHistory: ICTask[];
  selectedTask?: ICTask;
  isShowTaskModal: boolean;
};
const localStorage = new LocalStorageHelper();

const initialState: TaskProps = {
  taskDetailHistory: localStorage.getTaskTray(),
  isShowTaskModal: false,
};

export const taskSlice = createSlice({
  name: 'task',
  initialState,
  reducers: {
    postTaskHistory: (state, action: PayloadAction<ICTask>) => {
      state.taskDetailHistory.push(action.payload);
      localStorage.setTaskTray([...state.taskDetailHistory]);
    },
    deleteTaskHistory: (state, action: PayloadAction<string>) => {
      state.taskDetailHistory = state.taskDetailHistory.filter(
        (item: ICTask) => item.id !== action.payload
      );
      localStorage.setTaskTray(state.taskDetailHistory);
    },
    selectedTaskDetailUpdate: (
      state,
      action: PayloadAction<{ selectedTask?: ICTask; isShowTaskModal: boolean }>
    ) => {
      state.selectedTask = action.payload.selectedTask;
      state.isShowTaskModal = action.payload.isShowTaskModal;
    },
    postTaskTray: (state, action: PayloadAction<ICTask[]>) => {
      state.taskDetailHistory = action.payload;
    },
  },
});

export const {
  postTaskHistory,
  deleteTaskHistory,
  selectedTaskDetailUpdate,
  postTaskTray,
} = taskSlice.actions;

export const getTaskHistory = (state: RootState) => state.taskReducer;

export default taskSlice.reducer;
